import { type FC } from "react";
import { LoadingModal } from "@clientFrontend/features/scout/components/LoadingModal";
import { ConfirmBeforeActionModal } from "@clientFrontend/features/scout/components/ConfirmBeforeActionModal";
import { TextAreaWithWordCounter } from "./uiParts/TextAreaWithWordCounter"; // TODO: 類似パーツがコードベースに複数存在する。統一・リファクタを検討すること。
import { PcTemplateSelectAndAiTrigger } from "./uiParts/PcTemplateSelectAndAiTrigger";
import { SpTemplateSelectAndAiTrigger } from "./uiParts/SpTemplateSelectAndAiTrigger";
import { type PremiumScoutMessageAreaPresentationProps } from "./type";
import * as styles from "./styles.css";

export const Presentation: FC<PremiumScoutMessageAreaPresentationProps> = ({
  isSp,
  selectedValue,
  textAreaValue,
  disableText,
  displayDisableReason,
  options,
  textAreaRef,
  hasDisableAiScoutMessageReason,
  aiUsed,
  isShowSupplementModal,
  isShowLoadingModal,
  handlers,
  modals,
}) => {
  return (
    <>
      {isSp ? (
        <SpTemplateSelectAndAiTrigger
          options={options}
          selectedValue={selectedValue}
          handleSelectChange={handlers.handleSelectChange}
          handleClickOpenModal={handlers.handleClickOpenAiCreateConfirmModal}
          hasDisableAiScoutMessageReason={hasDisableAiScoutMessageReason}
          displayDisableReason={displayDisableReason}
          disableText={disableText}
          isShowSupplementModal={isShowSupplementModal}
          handleClickOpenSupplementModal={handlers.handleClickOpenSupplementModal}
          handleClickCloseSupplementModal={handlers.handleClickCloseSupplementModal}
        />
      ) : (
        <PcTemplateSelectAndAiTrigger
          options={options}
          selectedValue={selectedValue}
          handleSelectChange={handlers.handleSelectChange}
          handleClickOpenModal={handlers.handleClickOpenAiCreateConfirmModal}
          hasDisableAiScoutMessageReason={hasDisableAiScoutMessageReason}
          displayDisableReason={displayDisableReason}
          disableText={disableText}
        />
      )}
      {/* PC/SP共通の、「あなたをスカウトした理由」テキスト記入欄 */}
      <div className={styles.textAreaWrapper}>
        <TextAreaWithWordCounter
          value={textAreaValue}
          handleTextAreaChange={handlers.handleTextAreaChange}
          textAreaRef={textAreaRef}
          size="large"
        />
      </div>
      {/* PC/SP共通の、各種確認モーダル ex.AIでメッセージを作成しますか？ */}
      <ConfirmBeforeActionModal {...modals.aiCreateConfirm} />
      <ConfirmBeforeActionModal {...modals.overwriteTextAreaConfirm} />
      <ConfirmBeforeActionModal {...modals.reload} />
      <ConfirmBeforeActionModal {...modals.refetch} />
      {/* PC/SP共通の、AIで作成中Loadingモーダル */}
      {isShowLoadingModal && (
        <LoadingModal
          title="AIでメッセージを作成中..."
          description="1分程度かかることがあります。操作しないでお待ちください。"
        />
      )}
      {/* NOTE:画面表示後、一度でもAI機能を利用した場合、trueにし、プレミアムスカウト送信時にサーバ側へ送信するため */}
      <input type="hidden" name="ai_used" value={aiUsed ? "true" : "false"} />
    </>
  );
};
